* {
  scrollbar-width: none !important;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
}

body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  /* Disable bouncing on iOS*/
  overscroll-behavior: none;
  background: black;
}

#root {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-image: url('../src/shared/assets/backgrounds/background-pattern.jpg');
  background-repeat: repeat;
}
body {
  font-family: 'Inter', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

button,
a {
  cursor: pointer;
  text-decoration: none;
}

a:focus,
button:focus,
input:focus,
textarea:focus {
  outline: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
